import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from "@angular/core";

/**
 * Full-screen splash overlay shown while the WebGPU scene boots.
 * Displays the CastOffPro logo over a soft animated gradient and fades
 * out smoothly once the host signals readiness.
 */
@Component({
  selector: "po-splash-screen",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./splash-screen.component.html",
  styleUrl: "./splash-screen.component.css",
})
export class SplashScreenComponent {
  /** When true, splash starts fading out. */
  readonly ready = input<boolean>(false);

  protected readonly fading = signal(false);
  protected readonly visible = signal(true);

  constructor() {
    effect((onCleanup) => {
      if (!this.ready()) return;
      // The pre-bootstrap splash in index.html already gave the user plenty
      // of branded loading time, so once the scene reports ready we fade
      // out immediately without holding a fake minimum visible window.
      const fadeMs = 400;
      this.fading.set(true);
      const t = window.setTimeout(() => this.visible.set(false), fadeMs);
      onCleanup(() => window.clearTimeout(t));
    });
  }
}
